var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from 'clsx';
import breakpoints from '../../utils/breakpoints';
import { Inline } from '../inline/Inline';
import { Stack } from '../stack/Stack';
import { Radio } from '../radio/Radio';
import { RadioGroup } from '../radio_group/RadioGroup';
import { labelStyles, optionWrapperVariants, radioStyles, selectedOptionVariants, } from './AncillaryRadioGroup.css';
export const AncillaryRadioGroup = (_a) => {
    var { hasError, legend, name, onChange, options, selectedValue } = _a, props = __rest(_a, ["hasError", "legend", "name", "onChange", "options", "selectedValue"]);
    const legendId = `${name}-legend`;
    return (_jsx(RadioGroup, Object.assign({ "aria-labelledby": legend ? legendId : undefined, hasError: hasError, name: name, onChange: onChange, selectedValue: selectedValue }, props, { children: _jsxs(Stack, { spacing: 4, children: [legend && _jsx(RadioGroup.Legend, { id: legendId, children: legend }), _jsx(Inline, { collapseBelow: breakpoints._768, spacing: { [breakpoints._0]: 8, [breakpoints._768]: 0 }, children: options.map((_a, index) => {
                        var { id, label, value } = _a, rest = __rest(_a, ["id", "label", "value"]);
                        const isSelected = selectedValue === value;
                        return (_jsx("div", { className: cx(optionWrapperVariants[index === 0 ? 'first' : 'second'], selectedOptionVariants[isSelected ? 'selected' : 'notSelected']), children: _jsx(Radio.Label, Object.assign({ className: labelStyles, htmlFor: id }, rest, { children: _jsxs(Inline, { alignY: "center", as: "span", noWrap: true, spacing: 8, children: [_jsx(Radio, { className: radioStyles, id: id, value: value }), _jsx("span", { children: label })] }) })) }, `${name}-${id}`));
                    }) })] }) })));
};
